<template>
    <div class="headline-with-label">
        <h4>{{ label }} </h4>
        <h3 class="light">{{ headline }} </h3>
    </div>
</template>

<script>
export default {
    props: {
        headline: String,
        label: String
    }
}
</script>

<style lang="scss">
    @import '../../assets/scss/base.scss';
    .headline-with-label {
        padding: 0.8rem 1.5rem;
        @include lg() {
            padding: 0.15rem 1rem;
            h4 {
                margin-top: .25rem;
            }
            h3 {
                margin-bottom: .25rem;
            }
        }
    }
</style>

<style lang="scss" scoped>
    h4 {
        margin-bottom: 5px;
        opacity: 0.75;
    }
    h3 {
        margin-top: 5px;
    }
</style>